import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-brand-card" data-id="element-167">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-168">
        <FadeIn data-id="element-169">
          <div className="bg-brand-softGreen border-2 border-dashed border-brand-verifiedGreen p-8 md:p-12 rounded-3xl text-center shadow-lg" data-id="element-170">
            <ShieldCheck className="w-16 h-16 text-brand-accent mx-auto mb-6" data-id="element-171" />

            <h2 className="text-3xl font-bold text-brand-dark mb-6" data-id="element-172">
              🛡️ GARANTÍA TOTAL DE 30 DÍAS
            </h2>

            <div className="space-y-4 text-lg text-brand-muted" data-id="element-173">
              <p data-id="element-174">
                Si en 7 días aplicaste el protocolo y no notaste ningún cambio,
              </p>
              <p className="font-bold text-brand-accent text-xl" data-id="element-175">
                te devolvemos el 100% de tu inversión.
              </p>
              <p className="mt-6" data-id="element-176">Sin preguntas. Sin vueltas.</p>
              <p data-id="element-177">Porque estamos seguras de que esto funciona.</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}